define('widgets/widgets',[
	'jquery',
	'lib/jquery-ui/widget'
], function ($) {

	return $.widget('muse.widgets', {

		options: {
		},

		_create: function () {

			var widgets = {};

			this.$widgets = this.element.find('[data-widget]');
			this.$widgets.each(function () {

				var $el = $(this),
					widget = $el.data('widget');

				widget = widget.replace('-', '.');

				// console.log('init ' + widget + ' ' + $el.prop('tagName') + ($el.attr('id') ? '#' + $el.attr('id') : ''));

				widgets[widget] = $el[widget]().add(widgets[widget]);

			});

			this.widgets = widgets;
			return this._super();

		},

		_init: function() {

			if (this.option('disabled'))
				this.enable();

		},

		enable: function () {

			$.each(this.widgets, function (widget, $el) {
				console.log('enable ' + widget + ' (' + $el.length + ')');
				$el[widget]('enable');
			});
			this._super();

		},

		disable: function () {

			$.each(this.widgets, function (widget, $el) {
				console.log('disable ' + widget + ' (' + $el.length + ')');
				$el[widget]('disable');
			});
			this._super();

		}

	});

});
